import React, { useState } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import Image from 'next/image';

import { routes } from '@/infrastructure/const/routes';
import { Reciter } from '@/infrastructure/class/reciter';
import { EMPTY_COVER_IMAGE_PATH } from '@/infrastructure/const/empty-image-path';
import { getResponsiveImageLoader } from '@/utils/helpers/get-responsive-image-loader';
import s from './styles.module.scss';

interface IRecitersCarouselProps {
  data: Reciter;
  className?: string;
  imageLoadingEager?: boolean;
}

const RecitersFeaturedCarouselItem: React.FC<IRecitersCarouselProps> = (
  props
) => {
  const { className, data, imageLoadingEager = true } = props;

  const [background] = useState<string>(
    !!data.featureCover
      ? data.featureCover.mediumUrl ||
          data.featureCover.optimizedUrl ||
          data.featureCover.smallUrl
      : EMPTY_COVER_IMAGE_PATH
  );

  const imageLoading = imageLoadingEager ? 'eager' : 'lazy';
  const carouselItemClassNames = classNames(s['carousel-item'], className);

  return (
    <Link
      className={carouselItemClassNames}
      href={`${routes.reciters}/${data.slug}`}
      prefetch={false}
      passHref
    >
      <Image
        className={s['image']}
        loading={imageLoading}
        alt={data.titleEn}
        src={background}
        loader={
          data.featureCover
            ? getResponsiveImageLoader(data.featureCover)
            : undefined
        }
        fill
        sizes="(max-width: 600px) 100%, 300px"
        fetchPriority={imageLoadingEager ? 'high' : 'auto'}
      />
      <p className={s['title']}>{data.titleEn}</p>
    </Link>
  );
};

export default RecitersFeaturedCarouselItem;
